import {Component, OnInit} from '@angular/core';
import {UserSearchCity} from '@models/search';
import {SEARCH_CITY_PARAMS} from '@models/empty';
import {UserService} from '@services/user.service';
import {Router} from '@angular/router';

@Component({
    selector: 'app-new-city',
    template: '',
})
export class NewCityComponent implements OnInit {

    constructor(private userService: UserService, private router: Router) {
    }

    ngOnInit(): void {
        var currentSearch: UserSearchCity = ({} as UserSearchCity);
        currentSearch.search_city_params = JSON.parse(JSON.stringify(SEARCH_CITY_PARAMS)); // clone : ne pas contaminer la constante partagée

        this.userService.setCurrentSearchCity(currentSearch);
        this.router.navigate(['/app/city/result']);
    }
}
